import { DataGate } from '../components/shell/PageBody.tsx';
import { InboxSkeleton, InboxView } from '../features/approvals/InboxView.tsx';
import { SessionDrawerHost } from '../features/sessions/SessionDrawer.tsx';

/**
 * Inbox: everything that needs you, as one triage list beside the selected item in full.
 * Requests first (soonest deadline), then blocked requests, assistant steps and questions.
 */
export default function Inbox() {
  return (
    <DataGate skeleton={<InboxSkeleton />}>
      <InboxView />
      <SessionDrawerHost />
    </DataGate>
  );
}
